<button class="btn-print" (click)="print()">
    <mat-icon>print</mat-icon>&nbsp;<span>{{'Print' | translate}}</span>
</button>     
